import AssessmentIcon from '@mui/icons-material/Assessment';
import AssessmentList from './AssessmentList';

export default {
    list: AssessmentList,
    icon: AssessmentIcon,
    recordRepresentation: (record: any) => record.title,
};
